import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import "bootstrap/dist/css/bootstrap.min.css";

const SeverityDistribution = ({ trendsData }) => {
  const [findingsChart, setFindingsChart] = useState({
    series: [0, 0, 0, 0], // Default values for severity levels
    options: {
      chart: {
        type: "donut",
        height: 350,
        dropShadow: {
          enabled: true,
          top: 5,
          left: 5,
          blur: 10,
          opacity: 0.3,
        },
        toolbar: {
          show: false, // Removes unnecessary toolbar
        },
      },
      labels: ["Critical", "High", "Medium", "Low"],
      plotOptions: {
        pie: {
          donut: {
            size: "70%",
            labels: {
              show: true,
              total: {
                show: true,
                label: "Total Findings",
                fontSize: "16px",
                fontWeight: 600,
                color: "#333",
                formatter: function (w) {
                  // Calculate the total of all severity values
                  return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                },
              },
            },
          },
          expandOnClick: true,
        },
      },
      colors: [
        "rgba(244, 67, 54, 0.9)", // Critical
        "rgba(255, 152, 0, 0.9)", // High
        "rgba(76, 175, 80, 0.9)", // Medium
        "rgba(33, 150, 243, 0.9)", // Low
      ],
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "vertical",
          shadeIntensity: 0.5,
          gradientToColors: ["#FF616D", "#FFC107", "#81C784", "#64B5F6"],
          opacityFrom: 0.9,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["#fff"],
      },
      legend: {
        position: "bottom",
        horizontalAlign: "center",
        fontSize: "12px",
        labels: {
          colors: "#333",
          useSeriesColors: false,
        },
        markers: {
          radius: 5,
        },
        itemMargin: {
          horizontal: 6,
          vertical: 4,
        },
        offsetY: 0,
      },
      yaxis: {
        title: {
          text: "Count",
          style: {
            fontSize: "14px",
            fontWeight: "bold",
            color: "#333",
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (value) {
            return `${value} findings`;
          },
        },
      },
    },
  });

  useEffect(() => {
    if (trendsData && trendsData.length > 0) {
      // Combine severity data from all accounts
      let criticalTotal = 0;
      let highTotal = 0;
      let mediumTotal = 0;
      let lowTotal = 0;
      
      trendsData.forEach(account => {
        // Parse severity distribution from the new API response format
        const severityDistribution = JSON.parse(
          account.severityDistribution || "{}"
        );
        
        criticalTotal += severityDistribution.Critical || 0;
        highTotal += severityDistribution.High || 0;
        mediumTotal += severityDistribution.Medium || 0;
        lowTotal += severityDistribution.Low || 0;
      });

      // Update chart series with combined severity data
      setFindingsChart((prevChart) => ({
        ...prevChart,
        series: [
          criticalTotal,
          highTotal,
          mediumTotal,
          lowTotal,
        ],
      }));
    }
  }, [trendsData]);

  return (
    <div
      className="rounded shadow p-3 pb-0"
      style={{
        background: 'rgba(255, 255, 255, 0.7)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        borderRadius: '16px',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
        height: "100%",
      }}
    >
      <h5 className="fw-bold text-muted mb-3" style={{ color: "#333" }}>
        Severity Distribution
      </h5>
      <Chart
        options={findingsChart.options}
        series={findingsChart.series}
        type="donut"
        height={360}
      />
    </div>
  );
};

export default SeverityDistribution;
